<template>
    <span class="field string-field">
        <input ref="field" class="form-input" type="text" v-model="innerValue" @blur="handleBlur"/>
    </span>
</template>

<script>
    //import Component from 'path/to/component'
    import FormElementMixin from '@/mixins/formElement.js'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {

        },
        created: function () {

        },
        data() {
            return {

            }
        },
        destroyed: function () {

        },
        methods: {
            changeHandler(){
                this.updateValue(this.$refs.field.value)
            },
            handleBlur(){
                this.$emit('validate')
            }
        },
        mixins:[
            FormElementMixin
        ],
        mounted: function () {

        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/elements/String.vue